import { getActiveSubscriptionPlanId, hasPaidPropertyAccess } from './subscription-access';
export type PropertyFeature = 'intelligence' | 'investment';

// Full CI is included in Intelligence and Advisory; Premium includes previews.
export const PROPERTY_FEATURE_ACCESS: Record<PropertyFeature, readonly string[]> = {
  intelligence: ['intelligence', 'advisory'],
  investment: ['intelligence', 'advisory'],
};

export function canAccessPropertyFeature(user: any, feature: PropertyFeature): boolean {
  return PROPERTY_FEATURE_ACCESS[feature].includes(getActiveSubscriptionPlanId(user));
}

export function propertyFeatureSession(user: any): string {
  const profile = user?.data ?? user;
  return `${profile?._id ?? profile?.id ?? ''}:${getActiveSubscriptionPlanId(user)}:${profile?.subsctions?.subscriptionStatus ?? profile?.subscriptionStatus ?? ''}:${profile?.subsctions?.subscriptionEndDate ?? profile?.subscriptionEndDate ?? ''}`;
}


// The server's existing view-status response is the only source of unlocked IDs.
export function isPropertyUnlocked(status: any, propertyId: string): boolean {
  return !!propertyId && Array.isArray(status?.viewedProperties) && status.viewedProperties.some((entry: any) =>
    (typeof entry === 'string' ? entry : entry?.propertyId?._id ?? entry?.propertyId) === propertyId);
}

export function canAccessProperty(user: any, status: any, propertyId: string): boolean {
  const profile = user?.data ?? user;
  return hasPaidPropertyAccess(user) || (!!profile && isPropertyUnlocked(status, propertyId));
}

export function isPropertyRestricted(user: any, status: any, propertyId: string): boolean {
  const profile = user?.data ?? user;
  return !!profile && !hasPaidPropertyAccess(user) && status != null
    && Number.isFinite(Number(status.viewedCount)) && Number.isFinite(Number(status.viewLimit))
    && Number(status.viewedCount) >= Number(status.viewLimit) && !isPropertyUnlocked(status, propertyId);
}
